import { Box } from "@chakra-ui/react";
import NotificationPanel from "pages/ConsolePage/NotificationPanel";
import React from "react";
import BackgroundImage from "components/Icons/ChinaUIIcons/BackgroundImage.png";

const DisplayArea = ({ children }) => {
  return (
    <>
      <NotificationPanel />
      <Box
        w={{ base: "100%", sm: "430px" }}
        mx={"auto"}
        minH={"100vh"}
        backgroundImage={BackgroundImage}
      >
        {children}
      </Box>
    </>
  );
};

export default DisplayArea;
